import { Layout } from '@components/common'
import { getConfig } from '@framework/api/config'
import { getAllCollections } from '@framework/collection'
import { GetStaticPaths, GetStaticPropsContext } from 'next'
import { getCollection } from '@framework/product'
import CollectionView from '@components/collection/CollectionView'
import { Collection } from '@common/types/collection'
import SEO from '@components/common/SEO/SEO'

const placeholderImage = '/static_images/ts-pool-supply-square-pool.jpg'

// fetch all of the products slugs
export const getStaticPaths: GetStaticPaths = async () => {
  const config = getConfig()
  const collections = await getAllCollections(config)

  return {
    paths: collections.map((collection: Collection) => {
      return {
        params: {
          slug: collection.path,
        },
      }
    }),
    fallback: 'blocking',
  }
}

// provide product speficic data to the page
export const getStaticProps = async ({
  params,
}: GetStaticPropsContext<{ slug: string }>) => {
  const config = getConfig()

  const { collection, productPagination } = await getCollection({
    config,
    variables: { slug: params?.slug, productPageCount: 48 },
  })

  if (!collection) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      collection,
      productPagination,
      params,
    },
    revalidate: 60 * 5,
  }
}

export default function CollectionSlug({
  collection,
  productPagination,
  params,
}: any) {
  return (
    <>
      <CollectionView
        collection={collection}
        productPagination={productPagination}
        collectionSlug={params.slug}
      />
      <SEO
        title={collection.title}
        description={collection.title}
        openGraph={{
          type: 'website',
          title: collection.title,
          description: collection.title,
          images: [
            {
              url: collection.image ? collection.image : placeholderImage,
              width: 1280,
              height: 720,
              alt: collection.title,
            },
          ],
        }}
      ></SEO>
    </>
  )
}

CollectionSlug.Layout = Layout
